<template>
  <div class="tab-buttons">
    <div
      class="item"
      v-for="item of items"
      :key="item.value"
      :class="{ active: item.value === modelValue, 'party-hero': isPartyHero() }"
      @click="onTabClick(item)"
    >
      {{ item.title }}
      <!-- 团队管理的红点 -->
      <span v-if="item.red" class="red-dot"></span>
    </div>
  </div>
</template>

<script setup>
import { isPartyHero } from '@/common/utils';

defineProps({
  modelValue: { type: [String, Number] },
  items: { type: Array, required: true },
});

const emit = defineEmits(['update:modelValue', 'change']);

const onTabClick = (item) => {
  emit('update:modelValue', item.value);
  emit('change', item.value);
  if (item.red) {
    emit('hideRed');
  }
};
</script>

<style lang="less" scoped>
.tab-buttons {
  display: flex;
  overflow-x: auto;
  // margin: 0 -8px;
  .item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    margin: 0 6px;
    height: 32px;
    background: #fff;
    border-radius: var(--border-radius-medium);
    font-weight: 600;
    flex-shrink: 0;
    cursor: pointer;

    &.active {
      background: linear-gradient(90deg, rgba(2, 185, 251, 0.1) 0%, rgba(3, 253, 232, 0.1) 98.28%);

      &.party-hero {
        background: rgba(221, 100, 251, 0.15);
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .tab-buttons {
    padding: 0 8px 8px;
  }
}
.red-dot {
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  margin-left: 4px;
}
</style>
